// extracted by mini-css-extract-plugin
module.exports = {"content":"IntegrationTransactionListHeader_content__10Pgp","label":"IntegrationTransactionListHeader_label__Yeq6d"};